var map = {
	"./Docker.png": 17322,
	"./FastAPI.png": 28199,
	"./Jupyter.png": 26970,
	"./MySQL.png": 46647,
	"./NumPy.png": 6160,
	"./Pandas.png": 59518,
	"./PyTorch.png": 67124,
	"./Python.png": 30147,
	"./Qiskit.png": 87966,
	"./Scrapy.png": 4681,
	"./Smartprix.png": 40131,
	"./Spring.png": 15762,
	"./Ubuntu.png": 91976,
	"./Vue.png": 63601,
	"./csv.png": 83993,
	"./dns.png": 10784,
	"./file.png": 74147,
	"./github.png": 19380,
	"./ipynb.png": 36989,
	"./pdf.png": 26831,
	"./scikit-learn.png": 80717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85994;